export default __webpack_public_path__ + "static/media/5.a7796215.gif";